import { useSelector } from "react-redux";
import {
  getQuestionById,
  getQuestionsAndAnswers,
  getSourceSystemContent,
  getSourceSystemIsBranchAppraisal
} from "../../../../store/selectors";
import { useDispatch } from "react-redux";
import {
  QuestionIds,
  questionPresentationContent,
  yesMaskValue
} from "../../../../data/QuestionPresentation";
import { appraisalSlice } from "../../../../store/slices/Appraisal";
import { useNavigate } from "react-router-dom";
import { sendEvent, setAnalyticsLabel } from "../../../../helpers/analytics";

function useMechanics() {
  const QUESTION_ID = QuestionIds.MECHANICSELECTRICS;
  const conditionQuestion = useSelector(
    getQuestionById("Condition", QUESTION_ID)
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isBranchAppraisal = useSelector(getSourceSystemIsBranchAppraisal);
  const { photosRequired } = useSelector(getSourceSystemContent);

  const {
    pageTitle,
    questionTooltip
  } = questionPresentationContent[QUESTION_ID];

  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const answer = questionsAndAnswers && questionsAndAnswers[QUESTION_ID];

const handleSubmit = (answers: number[] | null) => {
    const answer = answers && answers[0];
    if (answer === yesMaskValue) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("select"));
    }
    if (!answer) {
      return dispatch(appraisalSlice.actions.setQuestionValidation("radio"));
    }
    const photoQty = conditionQuestion.answers.find((a: { id: string }) => {
      return a.id.toString() === answer.toString();
    })?.imageQuantityRequired;
    dispatch(
      appraisalSlice.actions.setPhotosRequired({ [QUESTION_ID]: photoQty })
    );
    sendEvent("event", "interaction", {
      action: conditionQuestion.content,
      label: setAnalyticsLabel(conditionQuestion, answer),
    });
    if (isBranchAppraisal && photosRequired) {
      return navigate("/photos-intro");
    } else if (!isBranchAppraisal && photosRequired) {
      dispatch(appraisalSlice.actions.setAllQuestionsAnswered(true));
      return navigate("/photos-intro");
    } else {
      if (isBranchAppraisal) return navigate("/initial-offer");
      else {
        dispatch(appraisalSlice.actions.setAllQuestionsAnswered(true));
        return navigate("/estimated-offer");
      }
    }
  };
  return {
    question: conditionQuestion,
    questionTooltip,
    questionTitle: conditionQuestion.content,
    pageTitle,
    handleSubmit,
    answer
  };
}

export default useMechanics;
